import {gql} from "@apollo/client";

export const HEALTHCARE_GET_CALCULATION_DATA = gql`
	query CalculationData(
		$comparisonId: String!
	) {
		calculationData(comparisonId: $comparisonId)
	}
`;

export const HEALTHCARE_GET_EXTERNAL_LOGS = gql`
	query ExternalLogs(
		$comparisonId: String!
	) {
		externalLogs(comparisonId: $comparisonId) {
			category
			name
			content
		}
	}
`;
